"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortKeys = exports.getFilters = void 0;
var casing_1 = require("@owner/casing");
var common_1 = require("./common");
var getFilters = function (_a) {
    var consumable = _a.consumable, _b = _a.filters, customFilters = _b === void 0 ? [] : _b, _c = _a.lists, lists = _c === void 0 ? [] : _c, sellable = _a.sellable;
    var filters = __spreadArray(__spreadArray(__spreadArray([], __read(customFilters), false), [
        {
            name: 'linkedToBrand',
            type: 'Boolean',
        },
        {
            name: 'linkedToPos',
            type: 'Boolean',
        },
        {
            name: 'brandLevel',
            type: 'Boolean',
        },
        {
            name: 'available',
            type: 'Boolean',
        }
    ], false), __read(lists.map(function (_a) {
        var name = _a.name;
        return ({
            name: "has".concat((0, casing_1.camelToPascal)(name)),
            type: 'Boolean',
        });
    })), false);
    if (consumable) {
        filters.push({
            name: 'glutenFree',
            type: 'Boolean',
        }, {
            name: 'vegetarian',
            type: 'Boolean',
        }, {
            name: 'alcohol',
            type: 'Boolean',
        });
    }
    if (sellable)
        filters.push({ name: 'taxable', type: 'Boolean' });
    return filters;
};
exports.getFilters = getFilters;
var getSortKeys = function (_a) {
    var customSortKeys = _a.sortKeys, sellable = _a.sellable;
    var sortKeys = __spreadArray(__spreadArray([], __read(customSortKeys), false), [
        'name',
        'displayName',
        'createdAt',
        'updatedAt',
    ], false);
    if (sellable)
        sortKeys.push('amount', 'taxRate', 'metadata.totalRevenue', 'metadata.quantitySold');
    return (0, common_1.removeDuplicates)(sortKeys);
};
exports.getSortKeys = getSortKeys;
//# sourceMappingURL=filtering.js.map